// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/fonts/VCR.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: black;
  margin: 0px;
  font-family: "VCR";
  font-size: 24px;
  color: white;
  text-align: center;
  width: 100vw;
  height: 100vh;
  align-items: center;
  justify-items: center;
}

@font-face {
  font-family: "VCR";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: bold;
}

.fade {
  animation: fadeInAndOut 2s linear 0s 1 normal forwards;
  opacity: 0;
}

@keyframes fadeInAndOut {
  0% {
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  60% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.click-to-start:hover {
  color: #ed1c24;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,+DAAiD;EACjD,iBAAiB;AACnB;;AAEA;EACE,sDAAsD;EACtD,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,cAAc;EACd,eAAe;AACjB","sourcesContent":["body {\n  background-color: black;\n  margin: 0px;\n  font-family: \"VCR\";\n  font-size: 24px;\n  color: white;\n  text-align: center;\n  width: 100vw;\n  height: 100vh;\n  align-items: center;\n  justify-items: center;\n}\n\n@font-face {\n  font-family: \"VCR\";\n  src: url(assets/fonts/VCR.ttf) format(\"truetype\");\n  font-weight: bold;\n}\n\n.fade {\n  animation: fadeInAndOut 2s linear 0s 1 normal forwards;\n  opacity: 0;\n}\n\n@keyframes fadeInAndOut {\n  0% {\n    opacity: 0;\n  }\n  10% {\n    opacity: 1;\n  }\n  60% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n.click-to-start:hover {\n  color: #ed1c24;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
